/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);
import 'element-ui/lib/theme-chalk/index.css';
// 修改element-ui的样式的
import './assets/scss/element.scss'

// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
//element 按需引入,需要用组件先引入

import {
  Tooltip,
  Form,
  FormItem,
  Tree,
  Input,
  Select,
  Option,
  Row,
  Col,
  Upload,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Divider,
  Image,
} from 'element-ui';
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tree);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Divider);
Vue.use(Image);
// axios
import request from '@/utils/ajax';
Vue.prototype.$http = request;

import i18n from './lang'
// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'



// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// 一些在各种媒体查询下的显示隐藏类
import '@/assets/scss/media.scss'
// 修改vuasax ui库的样式
import '@/assets/scss/vuesaxChange.scss'
//公共样式
import '@/assets/scss/public.scss'




Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

